<template>
  <section>
    <b-modal
      id="import-offer-modal"
      ref="import-offer-modal"
      size="sm"
      @shown="logStatus = 'Waiting for files to be imported...'; onImporting = true;"
      @hide="resetModal"
      title="Import Offer"
      no-close-on-backdrop
    >
      <div class="modal-body">
        <a href="/files/OfferImportFile.xlsx" download>
          <i class="fa fa-file"></i>
          Download Template File
        </a>

        <b-form-group  label="Vendor" style="grid-column: 3/5; grid-row: 1;" class="mt-1 mr-2 required">
          <b-input-group size="sm">
            <b-input-group-append v-if="checkClaim(CAN_ADD_COMPANY) || checkClaim(CAN_EDIT_COMPANY)">
              <b-button variant="light" @click="showCompanyForm">
                <i v-if="checkClaim(CAN_ADD_COMPANY)" v-show="this.selectedVendor.id == undefined || this.selectedVendor.id == null || this.selectedVendor.id == 0" class="customer-lookup--plus fa fa-plus"></i>
                <i v-if="checkClaim(CAN_EDIT_COMPANY)" v-show="this.selectedVendor.id > 0" class="customer-lookup--plus fa fa-pencil"></i>
              </b-button>
            </b-input-group-append>
            <vue-simple-suggest
              class="suggest-input form-control "
              :class="{ 'is-invalid': (this.vendorNameTouched && !chosenVendor) }"
              :styles="autoCompleteStyle"
              :list="getVendorsList"
              :max-suggestions="20"
              :min-length="3"
              :debounce="200"
              v-model="chosenVendor"
              :filter-by-query="true"
              value-attribute="id"
              display-attribute="name"
              @select="onVendorSuggestSelect"
              @input="onVendorSuggestChange"
              @blur="onVendorSuggestBlur"
              @request-done="onRequestDone"
              autocomplete="off"
            >
              <div slot="misc-item-below" v-if="isLoadingVendor" class="misc-item">
                <span>Loading Vendor...</span>
              </div>
            </vue-simple-suggest>
          </b-input-group>
          <div class="invalid-feedback">
            <div v-if="!$v.formData.companyId.required && !chosenVendor">Vendor is required</div>
          </div>
        </b-form-group>

        <b-form-group label="Offer Import File" class="required mt-2">
          <b-form-file
            multiple
            v-model="formData.filesUpload"
            :disabled="isSaving || !onImporting"
            :file-name-formatter="formatNames"
            accept=".xlsx"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-form-invalid-feedback>Please select valid file to import Offer.</b-form-invalid-feedback>
        </b-form-group>
        <br/>
        <b-form-group>
          <b-textarea
            v-model="logStatus"
            disabled
            :style="`width: 100%`"
            :rows="5"
          />
        </b-form-group>
      </div>
      <template slot="modal-footer">
        <b-button @click="$bvModal.hide('import-offer-modal')">Close</b-button>
        <b-button variant="primary" @click="onImportOffer" v-if="onImporting" :disabled="isSaving">Import</b-button>
      </template>
    </b-modal>

    <edit-company
      ref="companyOfferForm"
      modalId="companyOfferForm"
      hiddenButton
      isNewVendor
      :id="selectedVendor.id"
      :companyName="chosenVendor"
      @currentCompany="onCurrentVendor"
      @cancel="chosenVendor = ''"
    />

  </section>
</template>

<script>
  import { mapActions } from 'vuex';
  import VueSimpleSuggest from 'vue-simple-suggest';
  import { required } from 'vuelidate/lib/validators';
  import { AUTO_COMPLETE_STYLES, VENDOR_ID } from '@/shared/constants';
  import EditCompany from '@/pages/Company/components/EditCompany';

  export default {
    components: {
      VueSimpleSuggest,
      EditCompany
    },
    data() {
      return {
        isSaving: false,
        formData: {
          companyId: null,
          filesUpload: null,
        },
        logStatus: null,
        onImporting: false,
        selectedVendor: {},
        vendorNameTouched: false,
        chosenVendor: '',
        vendorsList: [],
        isLoadingVendor: false,
        autoCompleteStyle: AUTO_COMPLETE_STYLES,
      };
    },
    validations: {
      formData: {
        companyId: { required },
        filesUpload: { required },
      },
    },
    methods: {
      ...mapActions('offers', ['importOffers']),
      ...mapActions('companies', ['getByNameAndAccountType']),
      formatNames(files) {
        return files[0].name;
      },
      resetModal(){
          this.formData = {
              companyId: null,
              filesUpload: null,
          };
          this.chosenVendor= '';
          this.selectedVendor = {}
      },
      async onImportOffer(e) {
        e.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        }
        let formData = new FormData();
        formData.append('companyId', this.formData.companyId);
        this.formData.filesUpload.forEach(element => {
          formData.append('files[]', element, element.name);
        });
        this.isSaving = true;
        this.logStatus += `\nStarted importing Offers...`
        const result = await this.importOffers(formData).catch((res) => {
          this.isSaving = false;
          this.resetModal()
          this.logStatus += `\nThere's an error encountered during import. Please check errors within the import file.`
        });

        if (result != null) {
          this.logStatus += `\n---------------------------------------------------------`
          this.logStatus += `\nSuccessfully imported Offer: ${result.successCount}`
          this.logStatus += `\nFailed imported Offer: ${result.failCount}`
          this.resetModal()
        }

        this.isSaving = false;
        this.onImporting = false;
        // this.$bvModal.hide(this.modalId);
        this.$emit('refreshGrid');
      },
      showCompanyForm() {
        this.$refs['companyOfferForm'].showModal();
      },
      async getVendorsList(name) {
        this.vendorsList = await this.getByNameAndAccountType({
          typeId: VENDOR_ID, name});
        return this.vendorsList;
      },
      setSelectedVendor(id, name) {
        this.selectedVendor = {
          id: id,
          name: name
        }
      },
      async onVendorSuggestSelect(suggestion) {
        this.setSelectedVendor(suggestion.id, suggestion.name);
        this.formData.companyId = suggestion.id;
        this.$v.formData.companyId.$touch();
      },
      async onVendorSuggestChange() {
        this.isLoadingVendor = true;
        if (this.selectedVendor.name && this.chosenVendor !== this.selectedVendor.name) {
          this.selectedVendor = { id: 0 };
          this.formData.companyId = null;
          this.$v.formData.companyId.$touch();
        }
      },
      async onVendorSuggestBlur() {
        this.vendorNameTouched = true;
        if(this.chosenVendor) {
          if (this.vendorsList.length > 0) {
            const findIndex = this.vendorsList.findIndex(x => this.chosenVendor.toLowerCase() == x.name.toLowerCase());

            if (findIndex > -1) {
              this.onVendorSuggestSelect(this.vendorsList[findIndex]);
            } else {
              this.vendorNotFoundConfirmation();
            }
          } else {
            this.vendorNotFoundConfirmation();
          }
        } // New company
      },
      async vendorNotFoundConfirmation() {
        const addConfirmed = await this.openConfirmBox({
          message: `${this.chosenVendor} is not in the database. Press Continue to add them.`,
          okTitle: 'Continue',
        });
        if (addConfirmed) {
          this.$refs['companyOfferForm'].showModal();
        } else {
          this.chosenName = "";
        }
      },
      async onCurrentVendor(val) {
        this.setSelectedVendor(val.id, val.name);
        this.formData.companyId = val.id;
        this.chosenVendor = val.name;
      },
      onRequestDone() {
        this.isLoadingVendor = false;
      },
    },
  }
</script>